import React from 'react';
import { SmartTable, SmartTableNewInterface } from 'soft_digi';
import { formatCurrency } from '../../services/core/CommonService';
import '../ElectricFuel.scss';

interface InputProps {
  dataIn: any;
}

const InvoiceVendorDetailsTable: React.FC<InputProps> = ({ dataIn }) => {
  const priceDisplay = (row: any) => formatCurrency(row?.price);
  const totalDisplay = (row: any) => formatCurrency(row?.total);

  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: 'S.NO', index: 's_no', type: 'sno', width: '5' },
    { title: 'Type', index: 'type_desc' },
    { title: 'Month Average', index: 'month_avg' },
    { title: 'Count', index: 'count' },
    { title: 'Min Units', index: 'min_units' },
    { title: 'Price', index: 'price', valueFunction: priceDisplay },
    { title: 'Total', index: 'total', valueFunction: totalDisplay },
  ];

  const summaryFields = [
    { label: 'Total Taxable', value: formatCurrency(dataIn?.total_taxable), icon: 'fa fa-file-text' },
    { label: 'GST Amount', value: formatCurrency(dataIn?.gst_amount), icon: 'fa fa-percent' },
    { label: 'Total Amount', value: formatCurrency(dataIn?.total_amount), icon: 'fa fa-money' },
  ];

  return (
    <>
      <div className="columns is-multiline mb-3">
        {summaryFields.map((field, idx) => (
          <div className="column is-4" key={idx}>
            <div className="detail-view-field">
              <p className="detail-view-label">
                <i className={`${field.icon} mr-1`}></i> {field.label}
              </p>
              <p className="detail-view-value has-text-weight-semibold">{field.value}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="smart-elf-table">
        <SmartTable
          columns={columns}
          data={dataIn?.sub_data || []}
          tableTop={[]}
          tableProps={{
            className: 'is-hoverable is-striped is-fullwidth',
            isResponsive: true,
            searchPlaceHolder: 'Search',
          }}
          paginationProps={{ pageSize: 1 }}
        />
      </div>
    </>
  );
};

export default InvoiceVendorDetailsTable;
